<template>
  <v-dialog v-model="add" max-width="700px" persistent>
    <v-card class="pa-3">
      <v-card-title class="primary elevation-4">
        <span class="headline white--text">Add New User</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>

              <ValidationProvider name="Application" rules="required" v-slot="{ errors }">

                <v-select
                  :items="application.filter(x => x.canAddNew == true)"
                  label="Select application"
                  name="Application"
                  item-value="id"
                  :error-messages="errors"
                  v-model="editedItem.applicationID"
                ></v-select>

              </ValidationProvider>

            </v-flex>

            <v-flex xs12 sm6 md4>

              <ValidationProvider name="Email" rules="required" v-slot="{ errors }">

                <v-text-field
                  label="Email"
                  name="Email"
                  :error-messages="errors"
                  v-model="editedItem.customerEmail"
                ></v-text-field>

              </ValidationProvider>

            </v-flex>

            <v-flex xs12 sm6 md4>

              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">

                <v-text-field
                  label="Name"
                  name="Name"
                  :error-messages="errors"
                  v-model="editedItem.customerName"
                ></v-text-field>

              </ValidationProvider>

            </v-flex>

            <v-flex xs12 sm6 md4>

              <ValidationProvider name="Auth Level" rules="required" v-slot="{ errors }">

                <v-select
                  :items="linkLevel"
                  label="Select auth level"
                  name="Auth Level"
                  :error-messages="errors"
                  v-model="editedItem.authGroupName"
                ></v-select>

              </ValidationProvider>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save()">Save</v-btn>
        <v-btn color="light-grey" @click="cancel()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: "AddUser",
	data () {
		return {
			editedItem: {
				authGroupID: 0,
				authGroupName: "Customer",
				dealerID: 0,
				applicationID: 2,
				customerName: "",
				customerEmail: ""
			},
			application: [
				{ id: 1, text: "Sign On Glass", canAddNew: true },
				{ id: 2, text: "LINK", canAddNew: true },
				{ id: 3, text: "GEEKS LINK", canAddNew: true }
			],
			linkLevel: ["Dealer", "Administrators"]
		};
	},
	props: {
		add: { type: Boolean, required: true }
	},
	methods: {
		cancel () {
			this.$emit("close");
		},
		save () {
			this.$emit("save", this.editedItem);
		}
	}
};
</script>
